import { InputField } from '../../UI/Input/InputField';
import AchDataFields from './ach-data-field/AchDataFields';
import SwiftDataFields from './swift-data-fields/SwiftDataFields';

const BankData = ({
  activeTab,
  name,
  surname,
  achRoutingNumber,
  accountNumber,
  accountType,
  swiftCode,
  ibanCode,
  accountNumberValidationMessage,
  ibanCodeValidationMessage,
  achRoutingNumberValidationMessage,
  swiftCodeValidationMessage,
  showModify,
  handleNameInputFn,
  handleSurnameInputFn,
  handleAchRoutingNumberFn,
  handleAccountNumberFn,
  handleAccountTypeFn,
  hadnleSwiftCodeFn,
  hadnleIbanCodeFn,
}: {
  activeTab: string;
  name?: string;
  surname?: string;
  achRoutingNumber?: string;
  accountNumber?: string;
  accountType?: string;
  swiftCode?: string;
  ibanCode?: string;
  accountNumberValidationMessage: string | null;
  ibanCodeValidationMessage: string | null;
  achRoutingNumberValidationMessage: string | null;
  swiftCodeValidationMessage: string | null;
  showModify: boolean;
  handleNameInputFn: (event: any) => void;
  handleSurnameInputFn: (event: any) => void;
  handleAchRoutingNumberFn: (event: any) => void;
  handleAccountNumberFn: (event: any) => void;
  handleAccountTypeFn: (event: any) => void;
  hadnleSwiftCodeFn: (event: any) => void;
  hadnleIbanCodeFn: (event: any) => void;
}) => {
  return (
    <div>
      <p className="text-primary text-[16px] mb-4">Bank details</p>
      <InputField label="Name" id="name" forId="name" type="text" value={name} className=" mb-3" onChange={handleNameInputFn} readOnly={!showModify} />
      <InputField
        label="Surname"
        id="surname"
        forId="surname"
        type="text"
        value={surname}
        className=" mb-3"
        onChange={handleSurnameInputFn}
        readOnly={!showModify}
      />
      {activeTab === 'ACH' ? (
        <AchDataFields
          achRoutingNumber={achRoutingNumber}
          handleAchRoutingNumberFn={handleAchRoutingNumberFn}
          accountNumber={accountNumber}
          handleAccountNumberFn={handleAccountNumberFn}
          accountType={accountType}
          handleAccountTypeFn={handleAccountTypeFn}
          accountNumberValidationMessage={accountNumberValidationMessage}
          achRoutingNumberValidationMessage={achRoutingNumberValidationMessage}
          activeTab={activeTab}
          showModify={showModify}
        />
      ) : (
        <SwiftDataFields
          swiftCode={swiftCode}
          hadnleSwiftCodeFn={hadnleSwiftCodeFn}
          ibanCode={ibanCode}
          hadnleIbanCodeFn={hadnleIbanCodeFn}
          ibanCodeValidationMessage={ibanCodeValidationMessage}
          swiftCodeValidationMessage={swiftCodeValidationMessage}
          showModify={showModify}
        />
      )}
    </div>
  );
};

export default BankData;
